import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";
import InfoIconTooltip from "app/pages/sales-intelligence/common-components/tooltip/InfoIconTooltip/InfoIconTooltip";

interface ICaptionProps {
    captionKey: string;
    tooltipKey?: string;
}

const Caption = ({ captionKey, tooltipKey }: ICaptionProps) => {
    const translate = useTranslation();

    return (
        <Flex
            alignItems="center"
            gap="6px"
            margin="0 0 8px"
        >
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon[300]}
            >
                {translate(captionKey)}
            </Text>

            {tooltipKey ? <InfoIconTooltip tooltipKey={tooltipKey} /> : null}
        </Flex>
    );
};

export default Caption;
